import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {configuredRadium} from '../../utils/General';
import SubmitButton from '../SubmitButton';
import ExpandButton from '../ExpandButton.jsx';
import NumberInput from '../NumberInput';
import FeatureList from './FeatureList';
import {extractValue} from './tariffNameMapping';
import {t} from "../Translate";

const styles = {
    marginTop10px: {
        marginTop: '10px',
    },
    suggestedName: {
        backgroundColor: 'rgb(4, 62, 92)',
        color: '#FFFFFF',
        borderRadius: '20px 20px 0 0'
    },
    verticalSeparator: {
        height: '1px',
        backgroundColor: '#DDE4F6',
        marginBottom: '10px',
    },
    chatService: {
        fontSize: '20px',
        color: '#09183A',
        textAlign: 'center',
        marginTop: '15px',
    },
    chatServiceInactive: {
        color: '#DDE4F6',
    },
    buttonWrapperStyles: {
        textAlign: 'center',
        marginTop: '18px',
    },
    tariffPrice: {
        color: 'rgb(4, 62, 92)',
        fontSize: '20px',
        textAlign: 'center',
    },
    expandButtonWrapper: {
        display: 'block',
        width: '100%',
        textAlign: 'center',
        marginTop: '20px',
    }
};

class Tariff extends Component {
    constructor(props) {
        super(props);
        this.state = {
            additionalClients: 0,
            additionalOperators: 0,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        const {tariff, handleSelect} = this.props;
        const {additionalClients, additionalOperators} = this.state;

        handleSelect({
            packageId: tariff.id,
            additionalClients,
            additionalOperators,
        });
    }

    render() {
        const {tariff, company, plan, user} = this.props;
        const isCurrentPlan = plan.tariffPackage.id === tariff.id;
        const {additionalClients, additionalOperators} = this.state;

        const {country} = company;

        const monthlyPrice = extractValue(tariff, 'PRICE_MONTHLY', country);
        const additionalOperatorsPrice = additionalOperators * extractValue(tariff, 'ADDITIONAL_OPERATOR_PRICE', country);
        const additionalClientsPrice = additionalClients * extractValue(tariff, 'ADDITIONAL_CLIENT_PRICE', country);

        const getPrice = () => (
            monthlyPrice + additionalOperatorsPrice + additionalClientsPrice
        );


        const tariffNameStyle = isCurrentPlan ? styles.suggestedName : [];

        const currency = country === 'am' ? '֏' : '$';

        return (
            <div className="tariffWrapper">
                <p className="title" style={tariffNameStyle}>
                    {extractValue(tariff, 'NAME').toUpperCase()}
                </p>
                <div className="contentWrapper">
                    <div style={styles.verticalSeparator}/>
                    <p style={styles.tariffPrice}>
                        <b>
                            <b>{`${getPrice()}${currency}`}</b>
                        </b>
                        <span
                            style={monthlyPrice === 0 ? {display: 'none'} : {display: 'inline-block'}}
                        >
                            /{t({text: "month", user})}
                       </span>
                    </p>
                    <div style={[styles.verticalSeparator, styles.marginTop10px]}/>
                    <FeatureList
                        features={extractValue(tariff, 'FEATURES')}
                    />
                    <div style={styles.buttonWrapperStyles}>
                        <NumberInput
                            user={user}
                            minValue={extractValue(tariff, 'OPERATORS_QUANTITY')}
                            value={extractValue(tariff, 'OPERATORS_QUANTITY') + additionalOperators}
                            text={t({text: "billingOperator", user})}
                            additionalText={t({text: "billingOneOperator", user})}
                            disabledText={t({text: "operator", user})}
                            additionalPrice={extractValue(tariff, 'ADDITIONAL_OPERATOR_PRICE', country)}
                            country={country}
                            handleSubmit={(value) => {
                                this.setState({additionalOperators: value - extractValue(tariff, 'OPERATORS_QUANTITY')});
                            }}
                        />
                    </div>
                    <div style={styles.buttonWrapperStyles}>
                        <NumberInput
                            user={user}
                            minValue={extractValue(tariff, 'CLIENTS_QUANTITY')}
                            value={extractValue(tariff, 'CLIENTS_QUANTITY') + additionalClients}
                            text={t({text: "billingBot", user})}
                            additionalText={t({text: "billingOneBot", user})}
                            disabledText={t({text: "client", user})}
                            additionalPrice={extractValue(tariff, 'ADDITIONAL_CLIENT_PRICE', country)}
                            country={country}
                            handleSubmit={(value) => {
                                this.setState({additionalClients: value - extractValue(tariff, 'CLIENTS_QUANTITY')});
                            }}
                        />
                    </div>
                    <div style={styles.expandButtonWrapper}>
                        <ExpandButton/>
                    </div>
                    <div className="submitButtonWrapper">
                        <SubmitButton handleClick={this.handleSubmit}
                                      text={t({text: "tryItNow", user})}
                                      color={isCurrentPlan ? 'orange' : 'white'}
                                      buttonId={extractValue(tariff, 'NAME')}/>
                    </div>
                </div>
            </div>
        );
    }
}

Tariff.propTypes = {
    tariff: PropTypes.object.isRequired,
    plan: PropTypes.object.isRequired,
    handleSelect: PropTypes.func.isRequired,
};

export default configuredRadium(Tariff);



// WEBPACK FOOTER //
// ./src/components/tariff/Tariff.jsx